import type { ControllerFieldState } from 'react-hook-form';
import { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

import { Checkbox, type CheckboxProps } from '../../../Toolkit/Inputs/Checkbox';

type FinanceCheckboxProps = Omit<
  CheckboxProps,
  'hasError' | 'errorMessage' | 'name'
> &
  ControllerFieldState & { name: string; isOptional?: boolean };

export const FinanceCheckbox = forwardRef<
  HTMLInputElement,
  FinanceCheckboxProps
>((props, ref) => {
  const { invalid, checked, onChange, ...rest } = props;
  const { clearErrors } = useFormContext();
  return (
    <Checkbox
      {...rest}
      hasError={invalid}
      errorMessage={props.error?.message}
      ref={ref}
      checked={checked}
      onChange={(newChecked) => {
        clearErrors(props.name);
        onChange?.(newChecked);
      }}
    />
  );
});

FinanceCheckbox.displayName = 'FinanceCheckbox';
